import type { App } from 'vue'
import { setupPermissionDirective } from './permission'

/**
 * 注册所有自定义指令
 * @param app Vue应用实例
 */
export function setupDirectives(app: App) {
  setupPermissionDirective(app)
}

// 导出单个指令（用于按需导入）
export { permissionDirective } from './permission'
